import React from "react"
import { ChartTemplate } from "./chart-template"
import { PieChart, BarChart, units } from "dc"
import { scaleBand } from "d3-scale"

const chartFunc = (divRef, data) => {
  const yearDim = data.dimension(function (d) {
    return +d.Year
  })
  const spendPerYear = yearDim.group().reduceSum(function (d) {
    return +d.Spent
  })

  const yearRingChart = new PieChart(divRef)
  yearRingChart
    .width(200)
    .height(200)
    .dimension(yearDim)
    .group(spendPerYear)
    .innerRadius(50)

  return yearRingChart
}

function remove_empty_bins(source_group) {
  return {
    all: function () {
      return source_group.all().filter(function (d) {
        return d.value != 0
      })
    },
  }
}

const histSpend = (divRef, data) => {
  const spendDim = data.dimension(function (d) {
    return Math.floor(d.Spent / 10)
  })
  const spendHist = spendDim.group().reduceCount()
  const nonEmptyHist = remove_empty_bins(spendHist)

  const spendHistChart = new BarChart(divRef)
  spendHistChart
    .width(300)
    .height(200)
    .dimension(spendDim)
    .group(nonEmptyHist)
    .x(scaleBand())
    .xUnits(units.ordinal)
    .elasticX(true)
    .elasticY(true)
  return spendHistChart
}

export default () => {
  return (
    <>
      <ChartTemplate chartFunction={chartFunc} />
      <ChartTemplate chartFunction={histSpend} />
    </>
  )
}
